var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('app-modal',{attrs:{"maxWidth":_vm.maxWidth,"maxHeight":_vm.maxHeight,"isClickMaskClose":false},on:{"close":_vm.hideModal}},[_c('div',{staticClass:"attr-memo"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('tinymce',{attrs:{"api-key":"aewz9o4jkqj7akqq1fk0jxhi5sub7jyxlhiwfhailv6fq3tr","id":"attr_value_memmo","init":{
        height: 500,
        contextmenu: 'link image inserttable | cell row column deletetable',
        contextmenu_never_use_native: true,
        paste_data_images: true,
        link_list: function (success) {
          success(_vm.linkList);
        },
        image_list: function (success) {
          success(_vm.imageList);
        }
      },"plugins":_vm.plugins},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}),_c('div',{staticClass:"attr-memo__actions"},[_c('el-button',{on:{"click":_vm.hideModal}},[_vm._v(" "+_vm._s(_vm.$t("attr_value_memo_cancel"))+" ")]),_c('el-button',{attrs:{"type":"success","disabled":_vm.disabledSave},on:{"click":_vm.save}},[_vm._v(" "+_vm._s(_vm.$t("attr_value_memo_save"))+" ")])],1)],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }